<template>
    <div class="clientInfo" >
        <div class="add_record_header" style="margin: 5px 0;">客户信息</div>
        <div class="client_detail right_margin">
            <div>职业信息：{{client.profession}}</div>
            <div>
                <div>收入信息：{{client.income}}</div>
                <div>月收入金额：{{client.income_sum}}</div>
            </div>
            <div>
                <div>房产信息：{{client.house}}</div>
                <div>月供金额：{{client.house_sum}}</div>
            </div>
            <div>
                <div>车辆信息：{{client.car}}</div>
                <div>月供金额：{{client.car_sum}}</div>
            </div>
            <div>
                <div>公积金：{{client.accumulation_fund}}</div>
                <div>缴存时间：{{client.accumulation_fund_time}}</div>
            </div>
            <div>
                <div>社保：{{client.social_security}}</div>
                <div>社保基数：{{client.social_security}}</div>
            </div>
            <div>
                <div>商业保险：{{client.commercial_insurance}}</div>
                <div>缴纳金额：{{client.commercial_insurance_date}}</div>
            </div>
            <div>
                <div>微粒贷：{{client.wei_li_dai}}</div>
                <div>额度：{{client.wei_li_dai_sum}}</div>
            </div>
            <div>
                <div>信用卡：{{client.credit_card}}</div>
                <div>总额度：{{client.credit_card_sum}}</div>
            </div>

            <div>
                <div>负债：{{client.liabilities}}</div>
                <div>负债：{{client.liabilities_money}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    export default {
        name: "clientMessage",
        props: ['client'],
        created() {
            this.loadData();
        },
        watch: {
            id() {
                this.loadData();
            }
        },
        computed: {
            ...mapGetters(['userInfo', 'token']),
        },
        data() {
            return {
            }
        },
        methods: {
            ...mapActions([
                'handleLogOut',
            ]),
            async loadData() {
            },
        },
    }
</script>

<style scoped lang="less">

    .right_margin {
        margin: 5px 0;
        color: #A39A96;
    }


    .client_detail {


        div {
            width: 100%;
            margin: 2px 0;
            display: flex;
            justify-content: space-between;

            div {
                width: 50%;
            }
        }
    }

    .clientInfo{
        background: white;
        padding: 5px 20px;
        margin-top: 10px;
        border-radius: 5px;
    }
    .add_record_header{
        font-size: 16px;
        font-weight: bold;
        color: #2A8BF6;
    }
</style>
